import styled, { css } from 'styled-components';

export const StepIndicatorContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 8px 4px 20px;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
  position: relative;
`;

type CircleProps = { active?: boolean; completed?: boolean };

export const StepCircle = styled.div<CircleProps>`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  z-index: 1;
  transition: all 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
    stroke: ${({ theme }) => theme.colors.brand.overPrimary};

    path {
      stroke: ${({ theme }) => theme.colors.brand.overPrimary};
    }
  }

  ${({ theme, active, completed }) => {
    const { primary } = theme.colors.brand;
    if (completed) {
      return css`
        background: ${primary};
        color: ${theme.colors.brand.overPrimary};
      `;
    }
    if (active) {
      return css`
        background: ${primary};
        color: ${theme.colors.brand.overPrimary};
        box-shadow: 0 0 0 4px ${theme.colors.brand.secondary};
      `;
    }
    return css`
      background: ${theme.colors.background.tertiary};
      color: ${theme.colors.element.placeholder};
    `;
  }}
`;

export const StepLabel = styled.span<CircleProps>`
  font-size: 12px;
  text-align: center;
  line-height: 1.2;
  ${({ theme, active, completed }) => css`
    color: ${active || completed ? theme.colors.brand.primary : theme.colors.element.placeholder};
    font-weight: ${active ? 600 : 400};
  `}
`;

type ConnectorProps = { filled?: boolean };

export const StepConnector = styled.div<ConnectorProps>`
  position: absolute;
  top: 13px;
  left: calc(50% + 18px);
  right: calc(-50% + 18px);
  height: 2px;
  z-index: 0;
  background: ${({ theme, filled }) => (filled ? theme.colors.brand.primary : theme.colors.background.tertiary)};
`;
